import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import BaseModel, { type IResourceName } from 'volta/models/base-model';

export const TagResourceName: IResourceName = {
  singular: 'tag',
  plural: 'tags'
};

/**
 * @class Tag Tag model
 * @extends BaseModel
 */
export default class Tag extends BaseModel {
  /**
   * The tag value
   */
  @attr('string') tag?: string;

  /**
   * The number of times the tag appears on the different entities
   */
  @attr('number') count?: number;

  /**
   * The warehouse ids the tag appears. An empty array is equivalent to all warehouses.
   */
  @attr('array', { defaultValue: () => [] })
  declare warehouseIds: string[];

  /**
   * The entity types where the tag can be found
   */
  @attr('array', { defaultValue: () => [] })
  declare entityTypes: string[];

  @attr('boolean', { defaultValue: false })
  declare removable: boolean;

  [Type] = 'tag' as const;
}
